import { useContext } from 'react'

import { TokenContext } from '../layouts/context'
import { decodeTokenCustomerId } from '../lib/auth/scope'

export function useCustomerId(): string | undefined {
  const token = useContext(TokenContext)
  if (!token) {
    return undefined
  }
  const customerId = decodeTokenCustomerId(token)
  return customerId
}
